import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import TestsRequests from "services/tests";
import RBTableHeading from "./RBTableHeading";
import RBTableItem from "./RBTableItem";

const RbTable = () => {
  const dispatch = useDispatch();
  const { vows, vowsCurrentPage, vowsTotalPage } = useSelector(
    ({ tests }) => tests
  );

  useEffect(() => {
    dispatch(TestsRequests.getVows(1));
  }, []);

  const handleChangePagination = (_, value) => {
    dispatch(TestsRequests.getVows(value));
  };

  return (
    <div className="Cmt-table-responsive">
      {vows &&
        (vows.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <RBTableHeading />
            </TableHead>
            <TableBody>
              {vows.map((item) => (
                <RBTableItem data={item} key={item._id} id={item._id} />
              ))}
            </TableBody>
          </Table>
        ))}
      {vows.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={vowsTotalPage}
            color="primary"
            page={vowsCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default RbTable;
